import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'

export default function FilePreview () {
  const mimeType = useValue('type')

  if (mimeType === null) {
    return null
  }

  if (mimeType.indexOf('image') > -1) {
    return (
      <Displays.Image name='url' />
    )
  }

  return (
    <UI.Button>
      <UI.WithIcon icon={<UI.Icons.Download />}>
        <Displays.Link
          name='url'
          label={<Translation name='generic.view_current_file' />}
        />
      </UI.WithIcon>
    </UI.Button>
  )
}
